var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-459 261 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-456.5 285h2.5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4h5v-6c0-.3.2-.5.5-.5s.5.2.5.5v6h5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4h5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4h5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4h5v-6c0-.3.2-.5.5-.5s.5.2.5.5v6h2v-7.6c0-1.1-.4-2.4-1.5-2.4h-32.7c-1.1 0-1.8 1.3-1.8 2.4v7.6h.5zm0 1c-.3 0-.5 0-.5-.1v.5c0 1.1.7 1.6 1.8 1.6h32.7c1.1 0 1.5-.5 1.5-1.6v-.4h-35.5z",
    fill: "#424D56"
  })));
}

export default SvgFilterSize;